export const NOTIFICATION_CRUD_PATH = "/notification/crudNotification";
export const NOTIFICATION_MARK_ALL_READ_PATH = "/notification/markAllRead";
export const NOTIFICATION_MARK_READ_PATH = "/notification/markRead";
export const NOTIFICATION_MARK_SECTION_READ_PATH = "/notification/markSectionRead";
export const NOTIFICATION_FILTER_CHOICES_PATH = "/notification/filterChoices";
export const NOTIFICATION_SECTION_COUNTS_PATH = "/notification/unreadCountsBySection";
export const NOTIFICATION_PUSH_SUBSCRIPTION_PATH = "/notification/crudPushSubscription";
export const NOTIFICATION_AREA_PATH = "/notification/notificationArea/";
export const NOTIFICATIONS_PAGE_SIZE = 10;

export const NOTIFICATION_AREA_CODES = [
  "salle",
  "services",
  "list",
  "colis",
  "cart",
  "cartBar",
  "ticketing",
  "messaging",
] as const;

export type NotificationAreaCode = (typeof NOTIFICATION_AREA_CODES)[number];

export type NotificationAreaPreferences = Record<NotificationAreaCode, boolean>;

export interface NotificationAreaField {
  pk: number;
  user: number;
  areas: NotificationAreaPreferences;
  updated_at: string;
}

export interface NotificationAreaResponse {
  status: string;
  field: NotificationAreaField;
}

export const NOTIFICATION_ENDPOINTS = {
  CRUD: (buildingPk: number | string) => `${NOTIFICATION_CRUD_PATH}/${buildingPk}/`,
  FILTER_CHOICES: (buildingPk: number | string) =>
    `${NOTIFICATION_FILTER_CHOICES_PATH}/${buildingPk}/`,
  MARK_ALL_READ: (buildingPk: number | string) =>
    `${NOTIFICATION_MARK_ALL_READ_PATH}/${buildingPk}/`,
  MARK_READ: (buildingPk: number | string) =>
    `${NOTIFICATION_MARK_READ_PATH}/${buildingPk}/`,
  MARK_SECTION_READ: (buildingPk: number | string) =>
    `${NOTIFICATION_MARK_SECTION_READ_PATH}/${buildingPk}/`,
  SECTION_COUNTS: (buildingPk: number | string) =>
    `${NOTIFICATION_SECTION_COUNTS_PATH}/${buildingPk}/`,
  PUSH_SUBSCRIPTION: (buildingPk: number | string) =>
    `${NOTIFICATION_PUSH_SUBSCRIPTION_PATH}/${buildingPk}/`,
  AREA: NOTIFICATION_AREA_PATH,
} as const;

export const DEFAULT_NOTIFICATION_AREA_PREFERENCES: NotificationAreaPreferences = {
  salle: true,
  services: true,
  list: true,
  colis: true,
  cart: true,
  cartBar: true,
  ticketing: true,
  messaging: true,
};
